<!-- Desktop Dialog (>=768px) -->
<dialog
  *ngIf="show && showModal === 'desktop'"
  class="pop-up"
  aria-labelledby="flyout-logged-in-header"
  aria-describedby="flyout-logged-in-description"
  aria-modal="true"
  role="dialog"
  #flyoutTrackerDesktop
>
  <div class="pop-up-box !w-fit !p-0 !max-h-fit" idpFlyoutPosition>
    <div class="pop-up-box-content !mt-0">
      <div class="flex flex-col">
        <idp-flyout
          [accountSummaryHeaderContent]="
            (accountSummaryHeader.accountSummaryHeaderDetails$ | ngrxPush) ||
            emptyAccountSummaryHeaderContentDetails
          "
          [todayTabContent]="
            (flyoutToday.flyoutTodayDetails$ | ngrxPush) ||
            emptyTodayTabContentDetails
          "
          [statusTracker]="
            (flyoutStatusTracker.trackerFacadeData$ | ngrxPush) ||
            emptyStatusTrackerDetails
          "
          [footerContent]="
            (flyoutFooter.flyoutFooterDetails$ | ngrxPush) ||
            emptyFlyoutFooterContentDetails
          "
          [isAlertAdvisory]="isAlertAdvisory"
          (tabClickTracking)="tabClickTrack($event)"
          (footerTracking)="onFooterAnalytics($event)"
          (logoutEvent)="flyoutFooter.logout()"
          (closeEvent)="closeEvent.emit()"
          (errorAnalyticsData)="updateTrackerErrorAnalyticsData($event)"
        ></idp-flyout>
      </div>
    </div>
  </div>
  <form method="dialog" class="pop-up-backdrop">
    <button (click)="closeEvent.emit()" aria-label="Close pop-up">Close</button>
  </form>
</dialog>

<!-- Mobile Dialog (<768px) -->
<dialog
  *ngIf="show && showModal === 'mobile'"
  class="general-modal !p-0"
  aria-labelledby="flyout-logged-in-header"
  aria-describedby="flyout-logged-in-description"
  aria-modal="true"
  role="dialog"
  #flyoutLoggedInMobile
>
  <div
    class="general-modal-box ml-auto tablet:!ml-0 w-full !h-[100dvh] max-h-webkit-fill tablet:!max-h-[100dvh] tablet:!h-[100dvh] tablet:!max-w-none !p-0 !pb-0 !mt-0 !flex !flex-col portrait:!overflow-hidden landscape:!overflow-y-auto"
  >
    <div
      class="general-modal-header flex items-center justify-end !flex-shrink-0 !pl-4 !pr-6 !py-2"
    >
      <button
        class="general-modal-close-button"
        (click)="closeMobileModal()"
        aria-label="Close modal"
      ></button>
    </div>
    <idp-flyout
      class="w-full !flex-1 !flex !flex-col !min-h-0 portrait:!min-h-0 landscape:!min-h-fit"
      [accountSummaryHeaderContent]="
        (accountSummaryHeader.accountSummaryHeaderDetails$ | ngrxPush) ||
        emptyAccountSummaryHeaderContentDetails
      "
      [todayTabContent]="
        (flyoutToday.flyoutTodayDetails$ | ngrxPush) ||
        emptyTodayTabContentDetails
      "
      [statusTracker]="
        (flyoutStatusTracker.trackerFacadeData$ | ngrxPush) ||
        emptyStatusTrackerDetails
      "
      [footerContent]="
        (flyoutFooter.flyoutFooterDetails$ | ngrxPush) ||
        emptyFlyoutFooterContentDetails
      "
      [isAlertAdvisory]="isAlertAdvisory"
      (tabClickTracking)="tabClickTrack($event)"
      (footerTracking)="onFooterAnalytics($event)"
      (logoutEvent)="flyoutFooter.logout()"
      (closeEvent)="closeMobileModal()"
      (errorAnalyticsData)="updateTrackerErrorAnalyticsData($event)"
    ></idp-flyout>
  </div>
  <form method="dialog" class="general-modal-backdrop">
    <button (click)="closeMobileModal()" aria-label="Close modal">Close</button>
  </form>
</dialog>
